// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__lfLFz","icon":"style_icon__2T0l4"};